import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { IClient } from '../../../shared/interfaces/IClient';
import { getUser } from '../../../core/store/actions/core.actions';
import { ClientService } from '../../services/client.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  loading = false;
  success = false;
  error = false;
  user: IClient;
  id: number;
  userIdFromRoute: string;
  currentUser: any;
  visible: boolean = true;
  changeType: boolean = true;

  viewPass() {
    this.visible = !this.visible;
    this.changeType = !this.changeType;
  }

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private store: Store<AppState>,
    private clientService: ClientService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.userIdFromRoute = params['id'];

      this.store.select('core').subscribe((state) => {
        this.user = JSON.parse(JSON.stringify(state.user));
        if (this.user) {
          this.id = this.user.id;
        } else {
          this.router.navigate(['/clients/dashboard']);
        }

        if (this.id) {
          if (this.userIdFromRoute !== this.id.toString() || !this.user) {
            this.router.navigate(['/clients/dashboard']);
          }
        }
      });
    });

    this.store.select('core').subscribe((state) => {
      this.user = JSON.parse(JSON.stringify(state.user));
      if (this.user) {
        this.user.subscriptions.forEach((sub) => { });
      }
    });
    this.changePasswordForm = this.fb.group(
      {
        newPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern('(?=.*[0-9])(?=.*[A-Z]).{8,}'),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordMatchValidator }
    );

    this.changePasswordForm.get('newPassword').valueChanges.subscribe(() => {
      this.changePasswordForm.get('confirmPassword').updateValueAndValidity();
    });

    this.changePasswordForm
      .get('confirmPassword')
      .valueChanges.subscribe(() => {
        this.changePasswordForm.get('newPassword').updateValueAndValidity();
      });
  }

  passwordMatchValidator(formGroup: FormGroup): { mismatch: boolean } | null {
    const newPassword = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { mismatch: true };
  }

  changePassword(): void {
    if (this.changePasswordForm.valid) {
      this.loading = true;
      const apiUrl = environment.apiUrl;
      const payload = { password: this.changePasswordForm.value.newPassword };

      this.http.post(`${apiUrl}client/changePassword`, payload).subscribe({
        next: () => {
          this.success = true;
          this.error = false;
          this.loading = false;

          this.changePasswordForm.reset();
        },
        error: (error) => {
          this.error = true;
          this.success = false;
          this.loading = false;
          console.error('Error al cambiar la contraseña: ', error);
        },
      });
    }
  }
}
